export default __webpack_public_path__ + "static/media/personal-user-data.d6c613ca.svg";